import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';

import { Box } from 'components/Box';
import { Button, SecondaryButtonRouterLink } from 'components/Button';
import Icon from 'components/Icon/Icon';
import { setHideSalarySurveyAd } from 'store/main/ducks/layout';
import { colors, fontWeights, gutterWidth, transition } from 'theme';
import { trackClicked, trackEventOnce } from 'utils/analytics';
import { NOTIFICATIONS, dismissNotification } from 'utils/localNotifications';

const CloseButton = styled(Button)`
  opacity: 0.7;
  transition: all ${transition};
  &:hover {
    opacity: 1;
  }
`;

export function SalarySurveyBanner() {
  const dispatch = useDispatch();

  const dismiss = () => {
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string' is not assignable to par... Remove this comment to see the full error message
    dismissNotification(NOTIFICATIONS.SALARY_SURVEY_CTA);
    dispatch(setHideSalarySurveyAd(true));
  };

  useEffect(() => {
    trackEventOnce('Displayed: Salary Survey Ad', {
      context: 'Header Banner',
    });
  }, []);
  return (
    <Box
      data-qa-id="banner-ad"
      data-ad-type="salary-survey"
      position="relative"
      zIndex={101}
      bg={colors.waterBlue}
      color="white"
    >
      <Box
        position="absolute"
        left={0}
        top={0}
        width={1}
        height="100%"
        backgroundImage="url('/static/images/salary-survey-banner.svg')"
        backgroundSize="cover"
        backgroundPosition="center"
      />
      <Box
        position="relative"
        minHeight={[80, null, null, 92]}
        width={1}
        px={gutterWidth / 2}
        py={12}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <Box pr={10} fontSize={[14, 16, null, 18]}>
          <Box
            display={['block', null, null, 'inline']}
            fontWeight={fontWeights.semiBold}
          >
            Take our 5 minute anonymous survey
          </Box>{' '}
          to learn how much you could be earning.
        </Box>
        <Box display="flex" alignItems="center" flex="0 0 auto">
          <SecondaryButtonRouterLink
            to="/survey"
            mr={16}
            square
            reverse
            onClick={() => {
              trackClicked('Clicked: Salary Survey Ad', {
                cta_type: 'Button',
                button_text: 'Take Our Survey',
                url: '/survey',
                context: 'Header Banner',
              });
            }}
          >
            <Box minHeight={24} display="flex" alignItems="center">
              <Box display={['none', null, null, 'block']}>Take Our Survey</Box>
              <Box display={['block', null, null, 'none']}>Take Our Survey</Box>
            </Box>
          </SecondaryButtonRouterLink>

          <CloseButton data-qa-id="close-banner-ad-button" onClick={dismiss}>
            <Icon name="close" width={16} fill="currentColor" />
          </CloseButton>
        </Box>
      </Box>
    </Box>
  );
}
